module.exports = __webpack_public_path__ + "img/Lishan_Su.4feb7dfe.png";